module.exports = __webpack_public_path__ + "static/media/css3.0f6fcba7.svg";